<template>
  <div>
    <v-layout ml-3 v-if="showSearchDate">
      <v-flex xs6 sm6 md3 v-if="showSearchDateOptions">
        <v-layout row wrap>
          <v-flex xs12 lg6>
            <v-select :items="getSearchDateKeys"
                      item-text="value"
                      item-value="key"
                      v-model="searchDateKey"
                      :color="Theme.GREEN"
                      label="查詢條件"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs6 sm6 md3>
        <date-picker :date="startDate" @updateDate="changeStartDate" date-string="起始日期"/>
      </v-flex>
      <v-flex xs6 sm6 md3>
        <date-picker :date="endDate" @updateDate="changeEndDate" date-string="結束日期"/>
      </v-flex>
    </v-layout>

    <!-- 回收特有篩選 > 價格篩選 -->
    <v-layout v-if="showPriceFilter">
      <v-flex md2>
        <v-select
          :items="priceFilterOptions"
          v-model="priceFilter.type"
          :color="Theme.GREEN"
          label="回收金額篩選"
        ></v-select>
      </v-flex>
      <v-flex md2 v-if="priceFilter.type !== -1">
        <v-text-field
          v-model="priceFilter.value"
          type="number"
          label="金額"
          :color="Theme.GREEN"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <!-- 回收特有篩選 > 新增的排序方式 -->
    <v-layout v-if="showSortOptions">
      <v-flex md2>
        <v-select
          :items="sortOptions"
          v-model="sortBy"
          :color="Theme.GREEN"
          label="排序方式"
        ></v-select>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex md1 xs8>
        <v-select :items="searchOptions" v-if="showSearchOptions"
                  item-text="value"
                  item-value="key"
                  v-model="searchKey"
                  :color="Theme.GREEN"
                  label="查詢條件"
        ></v-select>
      </v-flex>
      <v-flex md3 xs8>
        <v-text-field v-model="searchValue" label="搜尋"
                      v-on:keyup.enter="searchEvent"
                      :color="Theme.GREEN" placeholder="查詢"></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn class="mr-2" :color="Theme.GREEN" dark @click.prevent="searchEvent">搜尋</v-btn>
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
      <v-flex>
        <v-spacer></v-spacer>
        <v-btn style="float: right;" v-if="showAddButton" :color="Theme.GREEN" dark @click.prevent="addNewData">新增</v-btn>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import common from "@/mixins/common";
import DatePicker from "../components/DatePicker";

export default {
  name: "SearchView",
  components: {
    DatePicker
  },
  mixins:[common],
  props: {
    showSearchDate: Boolean,
    showSearchDateOptions: Boolean,
    showSearchOptions: Boolean,
    showAddButton: Boolean,
    searchOptions: Array,
    isRecycle: Boolean,
    showPriceFilter: {
      type: Boolean,
      default: false
    },
    showSortOptions: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      searchDateKey: 'grantDate',
      searchKey: 'name',
      searchValue:'',
      startDate:'',
      endDate:'',
      priceFilter: {
        type: -1,
        value: 0
      },
      priceFilterOptions: [
        { text: '不指定', value: -1 },
        { text: '>=', value: 0 },
        { text: '<=', value: 1 },
        { text: '=', value: 2 },
      ],
      sortBy: '',
      sortOptions: [
        { text: '回收日期', value: 'createdDate' },
        { text: '回收金額', value: 'price' }
      ]
    };
  },
  created() {
    this.setDefaultDate();
  },
  computed:{
    getSearchDateKeys() {
      return [
        { key: "grantDate", value: "撥款日" },
        { key: "sellEnterDate", value: "業積登記日" },
      ];
    },
  },
  mounted() {
    this.setDefaultDate();
  },
  methods:{
    setDefaultDate(){
      let todayDate = new Date();
      // todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth] = currentDate.split("-");
      this.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth] = endDate.split("-");

      this.endDate = `${futureYear}-${futureMonth}-${days}`;
      this.initEvent();
    },
    initEvent(){
      console.log(`initEvent == ${this.startDate} / ${this.endDate}`);
      if (this.showSearchOptions) {
        this.$emit('initEvent', { searchDateKey: this.searchDateKey, startDate: this.startDate, endDate:this.endDate,
          searchKey: this.searchKey, searchValue: this.searchValue });
      } else {
        this.$emit('initEvent', { searchDateKey: this.searchDateKey, startDate: this.startDate, endDate:this.endDate,
          searchKey: '', searchValue: this.searchValue });
      }
    },
    searchEvent(){
      if (this.showSearchOptions && this.isRecycle) {
        const searchParams = {
          searchDateKey: this.searchDateKey,
          startDate: this.startDate,
          endDate: this.endDate,
          priceFilter: this.showPriceFilter ? this.priceFilter : null,
          sortBy: this.showSortOptions ? this.sortBy : null,
          searchKey: this.searchKey,
          searchValue: this.searchValue
        };
        this.$emit('searchEvent', searchParams);
      } else if (this.showSearchOptions) {
        this.$emit('searchEvent', { searchDateKey: this.searchDateKey, startDate: this.startDate, endDate:this.endDate,
          searchKey: this.searchKey, searchValue: this.searchValue });
      } else {
        this.$emit('searchEvent', { searchDateKey: this.searchDateKey, startDate: this.startDate, endDate:this.endDate,
          searchKey: '', searchValue: this.searchValue });
      }
    },
    reset(){
      this.searchDateKey = this.showSearchDateOptions ? 'grantDate' :'';
      this.searchKey = this.showSearchOptions ? 'name' : '';
      this.searchValue = '';
      this.priceFilter = {
        type: -1,
        value: 0
      };
      this.sortBy = '';
      this.$emit('reset');
    },
    addNewData(){
      this.$emit('addEvent');
    },
    changeStartDate(date){
      console.log(`changeStartDate = ${date}`)
      this.startDate = date;
    },
    changeEndDate(date){
      console.log(`changeEndDate = ${date}`)
      this.endDate = date;
    }
  }
}
</script>

<style scoped>

</style>
